import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const Open = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const license = searchParams.get("license");
    if (!license) {
      window.location.href = "https://omnia360.ai";
      return;
    }

    const appUrl = `omnia360://signup?license=${license}`;
    const iosStoreUrl = "https://apps.apple.com/app/omnia360/id6746214465";
    const androidStoreUrl =
      "https://play.google.com/store/apps/details?id=dev.expo.erpmobile";

    const userAgent = navigator.userAgent || navigator.vendor;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /android/i.test(userAgent);

    const storeUrl = isIOS
      ? iosStoreUrl
      : isAndroid
      ? androidStoreUrl
      : "https://omnia360.ai";

    const timeout = setTimeout(() => {
      window.location.href = storeUrl;
    }, 3500);

    window.location.href = appUrl;

    return () => {
      clearTimeout(timeout);
    };
  }, [searchParams]);

  return <p>Redirecting to the app...</p>;
};

export default Open;
